<template lang="html">
	<div id="page__additional-services" class="center-panel">
		<md-content md-theme="white" v-bind:loading="progress">
			<AdditionalServicesMenu></AdditionalServicesMenu>
			<sort-table
				v-bind:columns="tableColumns" v-model="services" v-on:refresh="getServices" v-bind:per-page="perPage" link
				v-bind:total="additional_services_amount" v-on:create="addService" table-id="price-services" tableHeight="calc(100% - 48px)"
			>
				<template slot="markup_type" slot-scope="scope">
					<span> {{ (scope.item.markup_type === '2') ? 'Процентная' : 'Числовая' }} </span>
				</template>
				<template slot="active" slot-scope="scope">
					<span> {{ (scope.item.active === '1') ? 'Да' : 'Нет' }} </span>
				</template>
				<template slot="section" slot-scope="scope">
					<span v-if="sections[scope.item.section]"> {{sections[scope.item.section]}} </span>
					<span v-else> Не указан </span>
				</template>
				<template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" danger-light  rounded v-on:click.stop.prevent="onRemove(scope.item.id)"></z-icon-button>
                </template>
			</sort-table>
		</md-content>
	</div>
</template>
<script>
	import SortTable from "@/components/SortTable";
	import ZIconButton from '@/components/ZIconButton';
	import AdditionalServicesMenu from './AdditionalServicesMenu.vue';
	export default {
		components: { SortTable, ZIconButton, AdditionalServicesMenu },
		data() {
			return {
				tableColumns: [
					{ label: 'ID',               field: 'id',           sortable: true, default: true,},
					{ label: 'Название',         field: 'name',         sortable: true},
					{ label: 'Тип наценки',      field: 'markup_type',  sortable: true},
					{ label: 'Активность',       field: 'active',       sortable: true},
					{ label: 'Раздел',           field: 'section',      sortable: true},
					{ label: 'Сортировка',       field: 'sort',         sortable: true},
					{ label: '',                 field: 'actions' },
				],
				perPage: 50,
				sections: {
					package: 'Тара и упаковка',
					services: 'Дополнительные услуги'
				}
			}
		},
		computed: {
			/**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['get-services-list'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
			/**
			 * Список услуг
			 */
			services() {
				return this.$store.state.cost.additional_services.map(service => {
                    service.routerLink = {name: 'AdditionalService', params: {service_id: service.id}, query: this.$route.query};
                    return service;
                });
			},
			/**
			 * Количество услуг
			 */
			additional_services_amount() {
				return this.$store.state.cost.additional_services_amount
			}
		},
		methods: {
			/**
			 * Добавление услуги
			*/
			addService() {
				this.$router.push({ name: 'AdditionalService',  params: {service_id: 'new'} });
			},
			/**
			 * Получение услуг
			 */
			getServices(page, count, orderBy, orderType) {
				this.$store.commit('showProgressBar', 'get-services-list');
				this.$store.dispatch('cost/getAdditionalServices',{
					page: page, 
					order_by: orderBy, 
					order_type: orderType, 
					count: count, 
					filter: this.resolveQueryFilter(), 
					nocache: true
				}).finally(() => this.$store.commit('hideProgressBar', 'get-services-list'));
			},
			/**
			 * Фильтрация
			 */
			resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return null;
                let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), model = [], result = {model: [], relation: [], condition: 'and'};

                if (filter.section) model.push(['section', '=', filter.section]);
                if (parseInt(filter.active) >= 0) model.push(['active', '=', filter.active]);

                model.map((item, i) => {
                    result.model.push(item);
                    if (model[i+1]) result.model.push('and');
                });
                return result
            },
			/**
             * Удаление группы клиентов
             */
            removeService(id) {
                if (!id) return;
                this.$store.commit('showProgressBar', 'get-services-list');
                this.$store.dispatch('cost/removeAdditionalService', id)
                    .then(() => this.$root.$emit('refresh-table', 'price-services'))
                    .finally(() => this.$store.commit('hideProgressBar', 'get-services-list'));
            },
            /**
             * Модальное окно с подтверждением удаления группы
             */
            onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении услуги', 'Действие необратимо!',
                    () => this.removeService(id)
                );
            }
		},
	}
</script>



// WEBPACK FOOTER //
// AdditionalServices.vue?448c648e